module.exports = __webpack_public_path__ + "img/discover-card.5cbcb09e.svg";